import {CustomCheckbox} from "../../../../components/CustomCheckbox";
import SummaryItem from "./SummaryItem";
import {IconCardAuthentication} from "../../../../components/buttons/IconButtons";
import {AUTHENTICATION_MODE, TYPE_CAMERA_MODEL} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

const SummaryContainerAuthentication = ({data,t}) => {

    const getCameraTypeById = (id) => {
        return TYPE_CAMERA_MODEL[id] || null;
    };

    const textItem = [
        {
            label: 'read_again_after',
            value: data?.readAfter
        },
        {
            label: 'authentication_method',
            value: t(data?.authentication)
        },
        {
            label: 'number_attemps',
            value: data?.consecutiveOpeningsAllowed
        }
    ];
    const itemsA = [
        {
            label: 'facial_recognition',
            value: data?.facialRecognition
        },
        {
            label: 'qr_code_reader',
            value: data?.qr
        },
        {
            label: 'rfid_reader',
            value: data?.smartCard
        }
    ];
    const itemsB = [
        {
            label: 'pin',
            value: data?.pin
        },
        {
            label: 'fingerprint_reader',
            value: data?.fingerprint
        },
        {
            label: 'bluetooth_reader',
            value: data?.bluetooth
        }
    ];

    return (
          <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <IconCardAuthentication width={24} height={24}/>
                </div>
            </div>
            <div className={" col-12 col-md-11 row p-0"}>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsB.map((item) => (
                    <CustomCheckbox
                        marginbutton={true}
                        checked={item.value}
                        value={item.value}
                        label={item.label}
                        trans={item.label}
                        name={item.label}
                        disabled={true}
                    />
                ))}
                {textItem.map((item) => (
                    <SummaryItem
                        label={item.label}
                        value={item.value}
                        t={t}
                    />
                ))}
            </div>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsA.map((item) => (
                    <CustomCheckbox
                        marginbutton={true}
                        checked={item.value}
                        value={item.value}
                        label={item.label}
                        trans={item.label}
                        name={item.label}
                        disabled={true}
                    />
                ))}
                <div className={'d-flex justify-content-between gap-5'}>
                    <CustomCheckbox
                        marginbutton={true}
                        checked={data?.enableDistance}
                        value={data?.enableDistance}
                        label={'enable_distance'}
                        trans={'enable_distance'}
                        name={'enable_distance'}
                        disabled={true}
                    />
                    <SummaryItem
                        label={'distance'}
                        value={data?.distance}
                        t={t}
                    />
                </div>
                <div className={'d-flex justify-content-between gap-5'}>
                    <CustomCheckbox
                        marginbutton={true}
                        checked={data?.liveness}
                        value={data?.liveness}
                        label={'liveness'}
                        trans={'liveness'}
                        name={'liveness'}
                        disabled={true}
                    />
                    <SummaryItem
                        label={'camera_type_id'}
                        value={getCameraTypeById(data?.cameraTypeId)}
                        t={t}
                    />
                </div>

            </div>
            </div>
        </div>
    )

}

export default SummaryContainerAuthentication
